import { render, staticRenderFns } from "./productPrt.vue?vue&type=template&id=3d7aa282&scoped=true"
import script from "./productPrt.vue?vue&type=script&lang=js"
export * from "./productPrt.vue?vue&type=script&lang=js"
import style0 from "./productPrt.vue?vue&type=style&index=0&id=3d7aa282&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7aa282",
  null
  
)

export default component.exports